export const SET_CONFIGURATION = "SET_CONFIGURATION";
